<div class="input-group">
  <input type="text"
         class="form-control"
         [disabled]="!!employee?.id"
         [(ngModel)]="employeeLookupId"
         [ngModelOptions]="{standalone: true}"
         [required]="required"
         placeholder="Enter value and click search...">

  @if (form) {
    <input type="hidden" formControlName="employeeId">
  } @else {
    <input type="hidden" [value]="employee?.id">
  }

  <div class="input-group-append">
    @if (employee?.id) {
      <button
        type="button"
        class="clear-search-input"
        [hidden]="false"
        (click)="clearEmployeeField()">
        <i class="fas fa-times-circle"></i>
      </button>
    }
    <button type="button"
            class="btn btn-action"
            (click)="searchEmployee()"
            [disabled]="!!employee">
      <reporter-icon icon="Search"></reporter-icon>
    </button>
  </div>
</div>
